import { useContext } from 'react'
import { UserContext } from 'context/userContext'
import { Loading } from 'components/index'
import { Container } from './style'
import Informacoes from './Informações'
import Extrato from './Extrato'
import HomeCliente from './HomeCliente'
import Produtos from './Produtos'

export default function DetalhesCliente() {
  const { loading, clientOption } = useContext(UserContext)

  if (loading) return <Loading modal />
  return (
    <Container>
      {(() => {
        switch (clientOption) {
          case 'Produtos':
            return <Produtos />
          case 'Informações':
            return <Informacoes />
          case 'Extrato':
            return <Extrato />
          default:
            return <HomeCliente />
        }
      })()}
    </Container>
    // <Loading modal />
  )
}
